import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const getMerchantInfo = unaryRpc({
  name: "getMerchantInfo",
  input: z.object({ merchantId: z.string() }),
  output: z.object({
    found: z.boolean(),
    name: z.string().nullable(),
    storeUrl: z.string().nullable(),
  }),
});
